var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tooltip',{attrs:{"placement":"top"}},[_c('template',{slot:"title"},[_c('span',[_vm._v(_vm._s(_vm.message))])]),_c('a-button',{attrs:{"shape":"circle","icon":"question"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }